import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import { TEST_EXPERIMENTS } from 'app/shared/ab-testing/constants';

const abTestUtils = {
    getValidExperiment: (experimentName, experiments) => experiments.find(
        experiment => experiment.experimentName === experimentName
    ),

    isUnderExperiment: (experimentName = '', experimentList = []) => {
        const validExperiment = abTestUtils.getValidExperiment(experimentName, experimentList);

        return validExperiment ? validExperiment.version === 'Experiment' : false;
    },

    // Outputs list of active A/B test names from TEST_EXPERIMENTS object
    // in a way that experiment API call can handle:
    // e.g., "ExperimentFoo1.JIRA-1,ExperimentFoo2.JIRA-2,ExperimentFoo3.JIRA-3"
    stringifyExperimentNames() {
        const experimentNameArray = [];

        forEach(TEST_EXPERIMENTS, (obj = {}) => {
            if (obj.test && obj.isActive) {
                experimentNameArray.push(obj.test);
            }
        });

        if (isEmpty(experimentNameArray)) {
            return false;
        }

        return experimentNameArray.join(',');
    },
};

export default abTestUtils;
